import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getPackages = createAsyncThunk(
    "packages/getPackages",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${API_URL}/packages`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
const packagesSlice = createSlice({
    name: "packages",
    initialState: { packages: [], loading: false, error: null },
    reducers: { 
        clearPaymentError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPackages.pending, (state) => {
                state.loading = true;
            })
            .addCase(getPackages.fulfilled, (state, action) => {
                state.loading = false;
                state.packages = action.payload;
            })
            .addCase(getPackages.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});
export const { clearPaymentError } = packagesSlice.actions;

export default packagesSlice.reducer;